import {
  isMobile
} from "./chunk.YDQDJZUC.js";
import {
  debounce
} from "./chunk.NKAUZW5M.js";

// src/components/jb-menu/jb-menu-utils.ts
var menu = {
  primaryMenuHoverGraceAnimation: null,
  secondaryDesktopMenu: null,
  secondaryMenuHoverAnimation: null,
  secondaryMenuVisibilityAnimation: null,
  lastVisible2ndLevelMenu: null,
  conditionalDispatchFadeOutEvent: null
};
function activateSecondaryMenuItem(menuItem) {
  menuItem.classList.add("active");
}
function bindDesktopEvents(renderRoot) {
  const primaryDesktopMenuItems = renderRoot.querySelectorAll(
    ".primary-wrapper jb-menu-item"
  );
  const secondaryMenuLists = renderRoot.querySelectorAll(
    ".secondary-wrapper jb-secondary-menu-list"
  );
  primaryDesktopMenuItems.forEach((menuItem) => {
    menuItem.addEventListener("mouseenter", () => {
      clearSecondaryDesktopMenuAnimations();
      renderRoot.querySelectorAll(".primary jb-menu-item.active").forEach((item) => {
        item.shadowRoot?.querySelector(".active")?.classList.remove("active");
        item.classList.remove("active");
      });
      menu.secondaryMenuHoverAnimation = setTimeout(() => {
        const selectedSubmenu = menuItem.submenu;
        clearActivePrimaryMenuItemDesktop(renderRoot);
        menuItem.shadowRoot?.querySelector("div.menu-item")?.classList.add("active");
        menuItem.classList.add("active");
        fadeInSecondaryMenuDesktop(renderRoot, selectedSubmenu);
      }, 400);
    });
  });
  menu.secondaryDesktopMenu = renderRoot.querySelector(".secondary-wrapper");
  menu.secondaryDesktopMenu?.addEventListener("mouseenter", () => {
    clearPrimaryDesktopMenuGraceAnimations();
    const activeSecondaryMenu = renderRoot.querySelector(".secondary-wrapper .active");
    if (activeSecondaryMenu) {
      clearSecondaryDesktopMenuAnimations();
    }
  });
  setTimeout(() => {
    secondaryMenuLists.forEach((list) => {
      const secondaryDesktopMenuItems = list.shadowRoot?.querySelectorAll("ul jb-menu-item");
      secondaryDesktopMenuItems?.forEach((menuItem) => {
        menuItem.addEventListener("mouseenter", () => {
          activateSecondaryMenuItem(menuItem);
        });
        menuItem.addEventListener("mouseleave", () => deactivateSecondaryMenuItem(renderRoot));
      });
    });
  }, 100);
}
function bindEvents(renderRoot) {
  if (isMobile()) {
    bindMobileEvents(renderRoot);
  } else {
    bindDesktopEvents(renderRoot);
  }
  bindSharedEvents(renderRoot);
}
function bindMobileEvents(renderRoot) {
  const primaryMenuItems = renderRoot.querySelectorAll(".primary-wrapper jb-menu-item");
  primaryMenuItems.forEach((menuItem) => {
    menuItem.addEventListener("click", (e) => {
      const selectedSubmenu = menuItem.submenu;
      const secondaryMobileMenuItemList = renderRoot.querySelector(
        `jb-secondary-menu-list[data-belongs="${selectedSubmenu}"`
      );
      e.preventDefault();
      if (selectedSubmenu && secondaryMobileMenuItemList) {
        openSecondaryMenuMobile(renderRoot, selectedSubmenu);
      } else {
        window.location.href = menuItem.link.href ? menuItem.link.href : "#";
      }
    });
  });
  const backBtn = renderRoot.querySelector(".secondary-wrapper .submenu-header jb-button-back");
  backBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    closeSecondaryMenuMobile(renderRoot);
  });
}
function bindSharedEvents(renderRoot) {
  document.addEventListener("jbNavigationOpen", (e) => openMenu(renderRoot, e));
  document.addEventListener("jbMenuStartFadeOut", () => startMenuFadeOut(renderRoot));
  document.addEventListener("jbMenuFullFadeOut", (e) => closeMenu(renderRoot, e));
  window.addEventListener(
    "resize",
    debounce(() => {
      dispatchEvent(new Event("close"));
    }, 10)
  );
}
function clearActivePrimaryMenuItemDesktop(renderRoot) {
  const primaryMenuItem = renderRoot.querySelectorAll(".primary-wrapper .primary jb-menu-item");
  primaryMenuItem.forEach((item) => {
    item.shadowRoot?.querySelector(".active")?.classList.remove("active");
  });
}
function clearPrimaryDesktopMenuGraceAnimations() {
  if (menu.primaryMenuHoverGraceAnimation) {
    clearTimeout(menu.primaryMenuHoverGraceAnimation);
  }
}
function clearSecondaryDesktopMenuAnimations() {
  if (menu.secondaryMenuHoverAnimation) {
    clearTimeout(menu.secondaryMenuHoverAnimation);
  }
}
function closeMenu(renderRoot, e) {
  e.preventDefault();
  if (isMobile()) {
    const mobileMenuSecondaryWrapper = renderRoot.querySelector(".secondary-wrapper");
    const activeSecondaryMenuItemList = mobileMenuSecondaryWrapper?.querySelector(".active");
    if (activeSecondaryMenuItemList) {
      const parentMenu = activeSecondaryMenuItemList.dataset.belongs;
      const allMenuItems = renderRoot.querySelectorAll(
        ".primary-wrapper .primary jb-menu-item"
      );
      allMenuItems.forEach((menuItem) => {
        if (menuItem.submenu === parentMenu) {
          menuItem.classList.add("hidden");
        }
      });
    }
    removeTransitionalMenuItemEvent(renderRoot.querySelector(".primary-wrapper"));
    removeTransitionalMenuItemEvent(renderRoot.querySelector(".secondary-wrapper"));
    mobileMenuSecondaryWrapper?.removeEventListener("transitionend", menu.conditionalDispatchFadeOutEvent);
    renderRoot.querySelector("nav")?.classList.remove("active");
  } else {
    removeTransitionalMenuItemEvent(renderRoot.querySelector(".primary-wrapper"));
    renderRoot.querySelector("nav")?.classList.remove("active");
  }
}
function closeSecondaryMenuMobile(renderRoot) {
  const activeSecondaryMenuItemList = renderRoot.querySelector(
    ".secondary-wrapper jb-secondary-menu-list.active"
  );
  activeSecondaryMenuItemList?.classList.add("fade-out");
  renderRoot.querySelector(".primary-menu-list.primary")?.classList.remove("animating");
  activeSecondaryMenuItemList?.classList.remove("active");
  renderRoot.querySelector(".secondary-wrapper")?.classList.remove("active");
  resetPositionPrimaryMenuItemTitle(renderRoot, activeSecondaryMenuItemList.dataset.belongs);
  renderRoot.querySelector(".primary-wrapper")?.classList.remove("hidden");
  resetPrimaryMobileMenuItems(renderRoot, activeSecondaryMenuItemList.dataset.belongs);
  fadeOutSecondaryMenuItems(activeSecondaryMenuItemList);
  setTimeout(() => {
    renderRoot.querySelector(".primary-menu-list.primary")?.classList.add("initial-animations");
  }, 400);
  setTimeout(() => {
    renderRoot.querySelector(".primary-wrapper jb-menu-item.focused")?.focus();
    activeSecondaryMenuItemList.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
  }, 400);
}
function conditionalDispatchFadeOutEvent(renderRoot, e) {
  const mobileMenuSecondaryWrapper = renderRoot.querySelector(".secondary-wrapper");
  if (e.target === mobileMenuSecondaryWrapper) {
    dispatchFadeOutEvent();
  }
}
function deactivateSecondaryMenuItem(renderRoot) {
  const activeSecondaryMenu = renderRoot.querySelector("jb-secondary-menu-list.active");
  activeSecondaryMenu?.shadowRoot.querySelector(".active")?.classList.remove("active");
}
function dispatchFadeOutEvent() {
  document.dispatchEvent(new CustomEvent("jbMenuFullFadeOut"));
  dispatchTransitionCompleteEvent();
}
function dispatchTransitionCompleteEvent() {
  document.dispatchEvent(new CustomEvent("jbMenuTransitionComplete", { bubbles: true }));
}
function fadeInPrimaryMenuItems(renderRoot, activeMenu) {
  if (activeMenu) {
    const menuItems = activeMenu.querySelectorAll("jb-menu-item");
    menuItems.forEach((primMenuItem) => {
      primMenuItem.classList.remove("hidden");
    });
    const serviceItemWrapper = renderRoot.querySelector(
      ".primary-wrapper jb-service-navigation"
    );
    if (serviceItemWrapper) {
      serviceItemWrapper.classList.remove("hidden");
    }
  }
}
function fadeInSecondaryMenuDesktop(renderRoot, selectedSubmenu) {
  const secondaryDesktopMenuItemList = renderRoot.querySelector(
    `.secondary-wrapper jb-secondary-menu-list[data-belongs="${selectedSubmenu}"`
  );
  fadeOutSecondaryMenuDesktop(renderRoot);
  if (!secondaryDesktopMenuItemList) return;
  if (secondaryDesktopMenuItemList === menu.lastVisible2ndLevelMenu) {
    clearTimeout(menu.secondaryMenuVisibilityAnimation);
  }
  secondaryDesktopMenuItemList.classList.add("active");
  secondaryDesktopMenuItemList.classList.add("visible");
  fadeInSecondaryMenuItems(secondaryDesktopMenuItemList);
  menu.lastVisible2ndLevelMenu = secondaryDesktopMenuItemList;
}
function fadeInSecondaryMenuItems(activeSubmenu) {
  if (activeSubmenu) {
    const menuItems = activeSubmenu.shadowRoot?.querySelectorAll("jb-menu-item");
    menuItems?.forEach((primMenuItem) => {
      primMenuItem.classList.remove("hidden");
    });
  }
}
function fadeOutPrimaryMenuItems(renderRoot, activeMenu) {
  if (activeMenu) {
    const primaryMenuItems = [].slice.call(activeMenu.querySelectorAll("jb-menu-item"));
    primaryMenuItems.reverse().forEach((primMenuItem, index) => {
      primMenuItem.classList.add("hidden");
      if (index + 1 >= primaryMenuItems.length) {
        primMenuItem.addEventListener("transitionend", dispatchFadeOutEvent);
      }
    });
    const serviceItemWrapper = renderRoot.querySelector(
      ".primary-wrapper jb-service-navigation"
    );
    if (serviceItemWrapper) {
      serviceItemWrapper?.classList.add("hidden");
    }
  }
}
function fadeOutPrimaryMobileMenuItemsWithException(renderRoot, activeMenu) {
  if (renderRoot.querySelector(".primary-wrapper")) {
    const menuItems = renderRoot.querySelectorAll(".primary-wrapper jb-menu-item");
    menuItems.forEach((item) => {
      if (item.submenu === activeMenu) {
        const activeMenuItem = item;
        const activeMenuItemArrow = activeMenuItem.shadowRoot?.querySelector("jb-arrow-forward-icon");
        const serviceItemWrapper = renderRoot.querySelector(".primary-wrapper jb-service-navigation");
        menuItems.forEach((primMenuItem) => {
          if (primMenuItem !== activeMenuItem) {
            primMenuItem.setAttribute("hidden", "");
          } else {
            activeMenuItemArrow.classList.add("hidden");
          }
        });
        if (serviceItemWrapper) {
          serviceItemWrapper.classList.add("hidden");
        }
      }
    });
  }
}
function fadeOutSecondaryMenuDesktop(renderRoot) {
  const activeSecondaryWrapper = renderRoot.querySelector(".secondary-wrapper .active");
  const activeSecondaryItemList = activeSecondaryWrapper?.shadowRoot?.querySelector(".secondary");
  const activeSecondaryMenuItem = activeSecondaryItemList?.shadowRoot?.querySelector(".active");
  if (activeSecondaryWrapper && !activeSecondaryMenuItem) {
    activeSecondaryItemList?.classList.remove("active");
    activeSecondaryWrapper.classList.remove("active");
    fadeOutSecondaryMenuItems(activeSecondaryWrapper);
    menu.secondaryMenuVisibilityAnimation = setTimeout(() => {
      activeSecondaryWrapper.classList.remove("visible");
    }, 300);
  }
}
function removeTransitionalMenuItemEvent(activeMenu) {
  const menuItems = activeMenu?.querySelectorAll("jb-menu-item");
  menuItems?.forEach((primMenuItem) => {
    primMenuItem.removeEventListener("transitionend", dispatchFadeOutEvent);
  });
}
function fadeOutSecondaryMenuItems(activeSubmenu) {
  if (activeSubmenu) {
    const menuItems = activeSubmenu.shadowRoot?.querySelectorAll("jb-menu-item");
    menuItems?.forEach((primMenuItem) => {
      primMenuItem.classList.add("hidden");
    });
  }
}
function fadeOutSecondaryMenuWrapperMobile(renderRoot) {
  const mobileMenuSecondaryWrapper = renderRoot.querySelector(".wrapper .secondary-wrapper");
  if (mobileMenuSecondaryWrapper) {
    if (mobileMenuSecondaryWrapper.classList.contains("active")) {
      mobileMenuSecondaryWrapper.classList.add("fade-out");
      mobileMenuSecondaryWrapper.addEventListener("transitionend", menu.conditionalDispatchFadeOutEvent);
    }
  }
}
function initiateFadeOutSecondaryMenuDesktop(renderRoot, activePrimaryMenuItem) {
  clearPrimaryDesktopMenuGraceAnimations();
  menu.primaryMenuHoverGraceAnimation = setTimeout(() => {
    activePrimaryMenuItem?.shadowRoot?.querySelector(".active")?.classList.remove("active");
    activePrimaryMenuItem?.classList.remove("active");
    fadeOutSecondaryMenuDesktop(renderRoot);
    menu.primaryMenuHoverGraceAnimation = null;
  }, 400);
}
function openMenu(renderRoot, e) {
  e.preventDefault();
  if (isMobile()) {
    const activeSecondaryMenuItemList = renderRoot.querySelector(
      ".secondary-wrapper .active jb-secondary-menu-list"
    );
    setPrimaryMobileMenuToDefaultState(renderRoot);
    if (activeSecondaryMenuItemList) {
      const parentMenu = activeSecondaryMenuItemList.dataset.belongs;
      closeSecondaryMenuMobile(renderRoot);
      const fadeoutSecondaryMenuItemList = renderRoot.querySelector(".secondary-wrapper .fade-out");
      resetPositionPrimaryMenuItemTitle(renderRoot, parentMenu);
      fadeoutSecondaryMenuItemList.classList.remove("fade-out");
      fadeInSecondaryMenuItems(activeSecondaryMenuItemList);
    }
    fadeInPrimaryMenuItems(renderRoot, renderRoot.querySelector(".primary-wrapper"));
    renderRoot.querySelector("nav")?.classList.add("active");
  } else {
    fadeInPrimaryMenuItems(renderRoot, renderRoot.querySelector(".primary-wrapper"));
    renderRoot.querySelector("nav")?.classList.add("active");
  }
}
function openSecondaryMenuMobile(renderRoot, selectedSubmenu) {
  const secondaryMobileMenuItemList = renderRoot.querySelector(
    `jb-secondary-menu-list[data-belongs="${selectedSubmenu}"`
  );
  if (!secondaryMobileMenuItemList) return;
  renderRoot.querySelector(".primary-menu-list.primary")?.classList.remove("initial-animations");
  fadeOutPrimaryMobileMenuItemsWithException(renderRoot, selectedSubmenu);
  repositionActivePrimaryMenuItemTitle(renderRoot, selectedSubmenu);
  renderRoot.querySelector(".primary-menu-list.primary")?.classList.add("animating");
  setTimeout(() => {
    renderRoot.querySelector(".primary-wrapper")?.classList.add("hidden");
    renderRoot.querySelector(".secondary-wrapper")?.classList.add("active");
    secondaryMobileMenuItemList?.classList.add("active");
    fadeInSecondaryMenuItems(secondaryMobileMenuItemList);
    renderRoot.querySelector(".secondary-wrapper.active jb-secondary-menu-list.active")?.shadowRoot.querySelector("jb-menu-item")?.focus();
    secondaryMobileMenuItemList.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
  }, 500);
}
function resetPrimaryMobileMenuItems(renderRoot, activeMenu) {
  if (renderRoot.querySelector(".primary-wrapper")) {
    const menuItems = renderRoot.querySelectorAll(".primary-wrapper jb-menu-item");
    const activeMenuItems = renderRoot.querySelectorAll(
      ".primary-wrapper .primary jb-menu-item"
    );
    activeMenuItems.forEach((item) => {
      if (item.submenu === activeMenu) {
        const activeMenuItemArrow = item.shadowRoot?.querySelector("jb-arrow-forward-icon");
        menuItems.forEach((primMenuItem) => {
          if (primMenuItem !== item) {
            primMenuItem.removeAttribute("hidden");
          } else {
            activeMenuItemArrow?.classList.remove("hidden");
          }
        });
      }
    });
    const serviceItemWrapper = renderRoot.querySelector(".primary-wrapper jb-service-navigation");
    if (serviceItemWrapper) {
      serviceItemWrapper.classList.remove("hidden");
    }
  }
}
function setPrimaryMobileMenuToDefaultState(renderRoot) {
  if (renderRoot.querySelector(".primary-wrapper")) {
    const mobileMenuWrapper = renderRoot.querySelector(".secondary-wrapper .fade-out");
    const menuItems = renderRoot.querySelectorAll(".primary-wrapper jb-menu-item");
    menuItems.forEach((primMenuItem) => {
      primMenuItem.classList.add("hidden");
    });
    mobileMenuWrapper?.classList.remove("fade-out");
    renderRoot.querySelector(".primary-menu-list.primary")?.classList.add("initial-animations");
  }
}
function repositionActivePrimaryMenuItemTitle(renderRoot, activeMenu) {
  const backBtn = renderRoot.querySelector(".secondary-wrapper jb-button-back");
  const submenuTitle = renderRoot.querySelector(".secondary-wrapper .title");
  const submenuTag = renderRoot.querySelector(".secondary-wrapper .tag");
  const menuItems = renderRoot.querySelectorAll(".primary-wrapper jb-menu-item");
  menuItems.forEach((item) => {
    if (item.submenu === activeMenu) {
      const selectedMenuItem = item;
      const menuTitle = selectedMenuItem.shadowRoot?.querySelector("span");
      const menuTag = selectedMenuItem.shadowRoot?.querySelector("p");
      const selectedMenuListItem = selectedMenuItem.shadowRoot?.querySelector("div.menu-item");
      if (selectedMenuListItem) {
        const distance = backBtn.getBoundingClientRect().bottom - selectedMenuListItem.getBoundingClientRect().top - 5;
        selectedMenuListItem.style.transform = "translateY(" + distance + "px)";
        submenuTitle.innerHTML = menuTitle.innerHTML;
        if (menuTag) {
          submenuTag.innerHTML = menuTag.innerHTML;
        } else {
          submenuTag.classList.add("no-value");
        }
      }
    }
  });
}
function resetPositionPrimaryMenuItemTitle(renderRoot, activeMenu) {
  const submenuTitle = renderRoot.querySelector(".secondary-wrapper")?.querySelector(".title");
  const submenuTag = renderRoot.querySelector(".secondary-wrapper")?.querySelector(".tag");
  const a = renderRoot.querySelectorAll(`.primary-wrapper jb-menu-item`);
  a.forEach((item) => {
    if (item.submenu === activeMenu) {
      const selectedMenuItem = item?.shadowRoot?.querySelector("div.menu-item");
      selectedMenuItem.style.transform = "translateY(0px)";
    }
  });
  submenuTitle.innerHTML = "";
  submenuTag.innerHTML = "";
  submenuTag.classList.remove("no-value");
}
function startMenuFadeOut(renderRoot) {
  if (isMobile() && renderRoot.querySelector(".secondary-wrapper .active")) {
    fadeOutSecondaryMenuWrapperMobile(renderRoot);
  } else {
    fadeOutPrimaryMenuItems(renderRoot, renderRoot.querySelector(".primary-wrapper"));
  }
}

export {
  activateSecondaryMenuItem,
  bindDesktopEvents,
  bindEvents,
  bindMobileEvents,
  bindSharedEvents,
  clearActivePrimaryMenuItemDesktop,
  clearPrimaryDesktopMenuGraceAnimations,
  clearSecondaryDesktopMenuAnimations,
  closeMenu,
  closeSecondaryMenuMobile,
  conditionalDispatchFadeOutEvent,
  deactivateSecondaryMenuItem,
  dispatchFadeOutEvent,
  dispatchTransitionCompleteEvent,
  fadeInPrimaryMenuItems,
  fadeInSecondaryMenuDesktop,
  fadeInSecondaryMenuItems,
  fadeOutPrimaryMenuItems,
  fadeOutPrimaryMobileMenuItemsWithException,
  fadeOutSecondaryMenuDesktop,
  removeTransitionalMenuItemEvent,
  fadeOutSecondaryMenuItems,
  fadeOutSecondaryMenuWrapperMobile,
  initiateFadeOutSecondaryMenuDesktop,
  openMenu,
  openSecondaryMenuMobile,
  resetPrimaryMobileMenuItems,
  setPrimaryMobileMenuToDefaultState,
  repositionActivePrimaryMenuItemTitle,
  resetPositionPrimaryMenuItemTitle,
  startMenuFadeOut
};
